import React, { useMemo } from 'react';
import { WidgetLoader } from 'datastake-daf/dist/components';
import { useChartHelper, locationsColors, stakeholdersColors } from './helper';
import Style from './style';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const Chart = ({
  data,
  filter,
  resizeTrigger,
  t = (s) => s,
  noBorders = false,
  customHeight = null,
  showLoader = true,
}) => {
  const {
    container,
  } = useChartHelper({ data, type: filter, resizeTrigger, t, customHeight });

  const legendItems = useMemo(() => {
    let colors;
    switch (filter) {
      case 'location':
      case 'mineSite':
        colors = locationsColors;
        break;
      case 'supplyChainActor':
      case 'stakeholder':
        colors = stakeholdersColors;
        break;
      default:
        colors = null;
    }

    if (colors) {
      return ['1', '2', '3', '4', '5'].map((k) => (
        <div key={k} className="item colors-legend">
          <div style={{ background: colors[k] }} />
        </div>
      ));
    }

    return null;
  }, [filter]);

  return (
    <Style className={formatClassname([noBorders && 'no-borders'])}>
      <div ref={container} style={{ width: '100%', height: 525 }} />
      {(!!!data) ? (showLoader ? <WidgetLoader /> : null) : (
        <div className="legend">
          <div className="section main">
            <div className="item mr-3">
              <label>{t('Amount of Data Points')}</label>
            </div>
            <div className="item mr-1">
              <span>{t('Less')}</span>
            </div>
            <div className="item colors-legend legend-dp sm">
              <div />
            </div>
            <div className="item colors-legend legend-dp md">
              <div />
            </div>
            <div className="item colors-legend legend-dp lg">
              <div />
            </div>
            <div className="item ml-1 mr-1">
              <span>{t('More')}</span>
            </div>
          </div>
          <div className="section">
            <div className="item mr-1">
              <label>{t('Sources')}</label>
            </div>
            <div className="item mr-1">
              <span>{t('Less')}</span>
            </div>
            {legendItems.map((l) => l)}
            <div className="item mr-1">
              <span>{t('More')}</span>
            </div>
          </div>
        </div>
      )}
    </Style>
  );
}

export default Chart;
